import Logo from './logo.js';
import LogoShort from './logo-short.js';
import LogoMobile from './logo-mobile.js';
import LogoSingleColor from './logo-single-color.js';
import '../styles.js';
import AppLogo from './app-logo.js';

const LOGO_MOBILE_WIDTH = 87; // svg logo width for mobile header

export default {
	Logo,
	LogoShort,
	LogoMobile,
	LOGO_MOBILE_WIDTH,
	AppLogo,
	LogoSingleColor
};
